import React from 'react';
import className from 'classnames';
import { connect } from 'react-redux';
import { AgGridReact } from '@ag-grid-community/react';
import { AllCommunityModules } from '@ag-grid-community/all-modules';
import '@/assets/styles/components/data-table.scss';
import Header from '../../../../components/DataTable/Header';
import CustomRenderer from './CustomRenderer';
import CustomNoRow from '../../../../components/DataTable/CustomNoRow';
import CustomLoadingOverlay from '../../../../components/DataTable/CustomLoadingOverlay';
import { BROWSER, LANG_KEY } from '@/constants/app';
import { detectBrowsers } from '@/helpers/global';
import GridFooter from '../../../../components/DataTable/Footer';
class DataTable extends React.Component {
  static getDerivedStateFromProps(nProps, prevState) {
    if (nProps.data) {
      return {
        rowData: nProps.data
      }
    }
    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      modules: AllCommunityModules,
      columnDefs: [],
      paginationPageSize: props.pageSize,
      defaultColDef: {
        flex: 1,
        minWidth: 120,
        cellStyle: {},
        headerClass: 'app-table-header',
        editable: false,
        resizable: true,
        sortable: true,
        cellClass: 'align-right',
        cellRenderer: 'customRenderer',
        unSortIcon: true
      },
      rowStyle: {
        rowHeight: 30
      },
      scrollbarWidth: 4,
      rowData: null,
      getRowStyle: lastRowBorder,
      frameworkComponents: {
        customRenderer: CustomRenderer,
        customLoadingOverlay: CustomLoadingOverlay,
        customNoRowsOverlay: CustomNoRow,
      },
      tooltipShowDelay: 0,
      fireGridApi: null,
      renderColumnDefs: this.renderColumnDefs.bind(this),
      noRowsOverlayComponent: 'customNoRowsOverlay',
      loadingOverlayComponent: 'customLoadingOverlay',
      loadingOverlayComponentParams: { loadingMessage: 'common_msg_loading' },
      animateRows: false,
      suppressDragLeaveHidesColumns: true
    }
    this.updateDimensions = this.updateDimensions.bind(this);
    props.innerRef(this)
  }

  renderColumnDefs(columnDefs) {
    this.setState({
      columnDefs: columnDefs.map(v => (v.headerTooltip = v.headerName ? v.headerName : '-') && v)
    }, () => {
      this.updateDimensions();
    })
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setRowData(this.props.data);
    if (!this.props.autoSizeColumns) {
      this.gridApi.sizeColumnsToFit();
    }
    this.setState({ fireGridApi: this.gridApi })
    if (window !== 'undefined') {
      window.addEventListener('resize', this.updateDimensions, false);
    }
  };

  onFirstDataRendered = (params) => {
    if (this.props.autoSizeColumns) {
      params.columnApi.autoSizeAllColumns(false);
    }
  }

  componentDidMount() {
    const { columnDefs } = this.props;
    const browser = detectBrowsers()

    if (browser === BROWSER.CHROME) this.setState({ animateRows: true });
    columnDefs.map(col => {
      return { ...col }
    })
    // if (browser !== BROWSER.FIREFOX) this.setState({ scrollbarWidth: 4 });
    this.renderColumnDefs(columnDefs);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions, false);
  }

  updateDimensions = () => {
    if (!this.state.fireGridApi) return;
    if (!this.props.autoSizeColumns) {
      this.gridApi.sizeColumnsToFit();
    }
  }

  updateHeaderLanguage = () => {
    const { columnDefs } = this.state;
    columnDefs.forEach(col => {
      let text = this.props.language[col.colId];
      col.headerName = text ? text : col.headerName;
      col.headerTooltip = col.headerName
      if (col.children) {
        let children = col.children;
        children.forEach(child => {
          let childText = this.props.language[child.colId];
          child.headerName = childText ? childText : child.headerName;
        })
      }
    });
    this.gridApi.setColumnDefs(columnDefs)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language !== this.props.language) {
      this.updateHeaderLanguage();
      if (this.props.autoSizeColumns) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
          allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, false);
      }
    }
  }

  toggleLoadingOverlay(value) {
    if (this.gridApi) {
      if (value) {
        this.gridApi.showLoadingOverlay();
      } else {
        if (this.props.data.length == 0) {
          this.gridApi.showNoRowsOverlay();
        } else {
          this.gridApi.hideOverlay();
        }
      }
    }
  }

  reCreateGrid() {
    let newState = {
      ...this.state,
      isDestroyed: false,
    };
    this.setState(newState);
    const { columnDefs } = this.props;
    columnDefs.map(col => {
      return { ...col }
    })
    this.renderColumnDefs(columnDefs);
    this.gridApi.setAutoGroupColumnDef(columnDefs)
  }

  onPageChanged(page) {
    if (this.gridApi) {
      if (page === 0) {
        this.gridApi.paginationGoToFirstPage();
      } else if (page === this.props.data.length) {
        this.gridApi.paginationGoToLastPage();
      } else {
        this.gridApi.paginationGoToPage(page - 1);
      }
    }
  }

  render() {
    const { language, theme, ...props } = this.props;
    const { rowData, tooltipShowDelay, scrollbarWidth } = this.state;

    return (
      <div className="table-wrapper">
        {props.showHeader && <Header {...props} />}
        <div id="app-grid" className={className("ag-theme-custom-" + theme)}>
          <AgGridReact
            gridOptions={this.state.rowStyle}
            modules={this.state.modules}
            columnDefs={this.state.columnDefs}
            defaultColDef={this.state.defaultColDef}
            rowData={rowData}
            rowSelection={"multiple"}
            rowMultiSelectWithClick={false}
            suppressCellSelection={true}
            onGridReady={this.onGridReady}
            onFirstDataRendered={this.onFirstDataRendered}
            rowHeight={26}
            colResizeDefault={"shift"}
            animateRows={true}
            pagination={this.props.showPagination}
            suppressPaginationPanel={true}
            paginationPageSize={this.state.paginationPageSize}
            frameworkComponents={this.state.frameworkComponents}
            loadingOverlayComponent={this.state.loadingOverlayComponent}
            loadingOverlayComponentParams={
              this.state.loadingOverlayComponentParams
            }
            noRowsOverlayComponent={this.state.noRowsOverlayComponent}
            enableCellTextSelection
            debounceVerticalScrollbar={true}
            tooltipMouseTrack={true}
            tooltipShowDelay={tooltipShowDelay}
            suppressDragLeaveHidesColumns={this.state.suppressDragLeaveHidesColumns}
            scrollbarWidth={scrollbarWidth}
          />
        </div>
        {
          this.props.showPagination && <GridFooter
            data={this.props.data ? this.props.data : 0}
            onPageChanged={(page) => this.onPageChanged(page)}
            paginationPageSize={this.state.paginationPageSize}
          />
        }

      </div>
    )
  }
}

DataTable.defaultProps = {
  showHeader: false,
  showPagination: true,
  innerRef: () => { },
  autoSizeColumns: false,
  pageSize: 10
}

export default connect(
  state => ({
    language: state.app.language,
    theme: state.app.theme
  })
)(DataTable)

function lastRowBorder(params) {
  if (params.node.rowIndex == params.api.rowModel.rowsToDisplay.length - 1) {
    return { borderBottom: 'thick green' }
  }
  else {
    return {}
  }
}